import { PlusSquare, Store } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Lojas } from "shared/components/lojas/Lojas";
import { HeaderBusca } from "shared/components/headers/headerbusca/HeaderBusca";
import { buscadorLojasConfig } from "shared/config/buscadorConfigs";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./MinhasLojas.module.scss";

export const MinhasLojas: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageContainer
      title="Minhas Lojas"
      icon={<Store size={20} />}
      showDesktopSearch={true}
      desktopSearchProps={buscadorLojasConfig}
    >       <div className={styles.filtrosLojas}>
        <HeaderBusca
          buscadorProps={buscadorLojasConfig}
          showOrder={true}
          orderLabel="Ordenar A-Z"
        />
      </div>

      <div className={styles.containerAdd} onClick={() => navigate("/cadastroloja")}>
        <p>Adicionar Loja</p>
        <PlusSquare className={styles.iconAdd} />
      </div>
      <Lojas />
    </PageContainer>
  );
};